import "babel-polyfill";
import Vue from "vue";
import Vuex from "vuex";

//挂载Vuex
Vue.use(Vuex);

const SCREEN_WIDTH = document.body.offsetWidth;

//创建VueX对象
const store = new Vuex.Store({
  state: {
      userInfo: {}
  },
  mutations: {  
      changeUserInfo(state,val){
        state.userInfo = val
      }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js